<template>
  <div class="footer">
    <div class="contact-us-container">
      <img src="https://summit-img.geekpark.net/10-%E8%81%94%E7%B3%BB%E6%88%91%E4%BB%AC.svg"
           style="width:60vh;margin-left: 11vh">
      <div class="contact-us">
        <div class="item">
          <h2>观众咨询</h2>
          <a href="mailto:IFX@geekpark.net">
            <img src="https://summit-img.geekpark.net/ifx@geekpark.net.svg" style="width:26vh">
          </a>
        </div>
        <div class="item">
          <h2>商务合作</h2>
          <a href="mailto:IF.BD@geekpark.net">
            <img src="https://summit-img.geekpark.net/if.bd@geekpark.net.svg" style="width: 29vh">
          </a>
        </div>
        <div class="item">
          <h2>媒体联系</h2>
          <a href="mailto:IF.Media@geekpark.net">
            <img src="https://summit-img.geekpark.net/if.media@geekpark.ne.svg" style="width: 34vh;">
          </a>
        </div>
      </div>
      <div class="geek-parker">
        <h4>添加极客君微信好友（ID：GEEKGOGO），发送「IFX」即可加入大会用户交流群</h4>
      </div>
    </div>
    <div class="for-the-next-container" ref="forTheNextContainer">
      <img src="https://summit-img.geekpark.net/11-footer.svg" class="ifx-image" ref="ifxImage">
      <div class="for-the-next">
        <img src="https://summit-img.geekpark.net/11-footer-FOR-1.svg" style="width: 69vh"
             :style="{transform:`translate3d(${topImagePosition}px,0,0)`}">
        <img src="https://summit-img.geekpark.net/11-footer-THENEXT-2.svg" style="width: 170vh;"
             class="footerForTheNext"
             :style="{transform:`translate3d(${middleImagePosition}px,0,0)`}">
        <img src="https://summit-img.geekpark.net/11-footer-10YEARS-3.svg" style="width: 156.8vh"
             :style="{transform:`translate3d(${bottomImagePosition}px,0,0)`}">
      </div>
      <p style="position: absolute;right: 8.8%;bottom:7%;color: #B6B6B6;font-size: 1.6vh">Copyright ©2019 GEEKPARK</p>
    </div>
    <div class="if-container">
      <img src="https://summit-img.geekpark.net/footer-10th.svg"
           style="position: absolute;width: 90vh;left: -10vh;top: 40%">
      <div class="past-container">
        <div class="past-year">
          <img src="https://summit-img.geekpark.net/mobile/v2-%E5%BE%80%E5%B1%8A%E5%9B%9E%E9%A1%BE-%E7%BA%A2%E8%89%B2"
               style="width: 12.2vh;">
          <a href="http://if2019.geekpark.net/" target="_blank">
            <img src="https://summit-img.geekpark.net/ifx/pc/v2-%E5%BE%80%E5%B1%8A%E5%9B%9E%E9%A1%BE-2019.svg" alt="">
          </a>
          <a href="http://if2018.geekpark.net/" target="_blank">
            <img src="https://summit-img.geekpark.net/ifx/pc/v2-%E5%BE%80%E5%B1%8A%E5%9B%9E%E9%A1%BE-2018.svg" alt="">
          </a>
          <a href="http://if2017.geekpark.net/" target="_blank">
            <img src="https://summit-img.geekpark.net/ifx/pc/v2-%E5%BE%80%E5%B1%8A%E5%9B%9E%E9%A1%BE-2017.svg" alt="">
          </a>
          <a href="http://if2016.geekpark.net/" target="_blank">
            <img src="https://summit-img.geekpark.net/ifx/pc/v2-%E5%BE%80%E5%B1%8A%E5%9B%9E%E9%A1%BE-2016.svg" alt="">
          </a>
          <a href="http://if2015.geekpark.net/" target="_blank">
            <img src="https://summit-img.geekpark.net/ifx/pc/v2-%E5%BE%80%E5%B1%8A%E5%9B%9E%E9%A1%BE-2015.svg" alt="">
          </a>
        </div>
      </div>
    </div>
    <div class="logo-container" style="width: 100vw;height: 100vh;display: flex;justify-content: center;align-items: center;background: #ff3c00">
      <img src="https://summit-img.geekpark.net/ifx/pc/footer-GEEKPARK-LOGO-white.svg" alt="" style="width: 24.5vw">
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {
      scrollHeight: 0,
      topImagePosition: 0,
      middleImagePosition: 0,
      bottomImagePosition: 0
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll, false)
  },
  methods: {
    handleScroll () {
      const scrollHeight = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      const scrollInstance = scrollHeight - this.scrollHeight
      this.scrollHeight = scrollHeight
      const { left, width } = document.querySelector('.footerForTheNext').getBoundingClientRect()
      if (left <= document.body.offsetWidth && left >= -width) {
        if ((scrollInstance > 0 && this.topImagePosition >= -width) || (scrollInstance < 0 && this.topImagePosition <= 0)) {
          this.topImagePosition -= scrollInstance / 6
          this.middleImagePosition -= scrollInstance / 10
          this.bottomImagePosition -= scrollInstance / 4
        }
      }
      if (document.querySelector('.ifx-image').getBoundingClientRect().left <= document.body.offsetWidth / 4) {
        this.$refs.ifxImage.classList.add('ifx')
        this.$refs.forTheNextContainer.classList.add('for-the-next-frames')
      }
    }
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style scoped lang="less">
  .footer {
    display: flex;
    width: auto;
    height: 100%;
  }

  .contact-us-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-sizing: border-box;
    width: 100vh;
    padding: 10vh 0;
    background-color: #2d2d2d;
    text-align: left;
  }

  .contact-us {
    width: 80%;
    margin: auto;

    .item {
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #d8d8d8;

      &:not(:last-of-type) {
        margin-bottom: 4vh;
      }

      h2 {
        color: #fff;
        font-size: 6vh;
        font-weight: normal;
      }

      a {
        display: flex;
        justify-content: center;
      }
    }
  }

  .geek-parker {
    width: 80%;
    margin: 0 auto;
    color: #fff;
    font-size: 2vh;
  }

  @keyframes ifxFrames {
    from {
      left: 0;
      top: 0%;
      width: 131vh;
    }
    to {
      left: 25vh;
      top: 35%;
      width: 54.8vh;
    }
  }

  @keyframes bg {
    from {
      background: url("https://summit-img.geekpark.net/ifx/images/11-footer-%E5%B0%84%E7%BA%BF.png") 21% 50% ~"/" 0% auto no-repeat #1e1e1e;
    }
    to {
      background: url("https://summit-img.geekpark.net/ifx/images/11-footer-%E5%B0%84%E7%BA%BF.png") 50% 24% ~"/" 59% auto no-repeat #1e1e1e;
    }
  }

  .for-the-next-container {
    position: relative;
    width: 320vh;
    height: 100%;
    background-color: #1e1e1e;

    > img:first-of-type {
      position: absolute;
      left: 0;
      top: 0%;
      width: auto;
      height: 100vh;
      transition: all 1s;
    }

    > img.ifx {
      left: 0;
      top: 0%;
      width: 131vh;
      height: auto;
      animation: ifxFrames 1s forwards;
    }

  }

  .for-the-next-frames {
    background: url("https://summit-img.geekpark.net/ifx/images/11-footer-%E5%B0%84%E7%BA%BF.png") 21% 50% ~"/" 0% auto no-repeat #1e1e1e;
    animation: bg 1s forwards;
    animation-delay: 0.8s;
  }

  .for-the-next {
    position: absolute;
    left: 100vh;
    top: 18%;
    width: 200vh;

    img {
      display: block;
      transition: transform .5s ease-out;
    }

    img:first-of-type {
      margin-left: 32.2vh;
    }

    img:nth-child(2) {
      margin: 4vh 0 4vh 10vh;
    }

    img:last-of-type {
      margin-left: 45vh;
    }
  }

  .if-container {
    position: relative;
    width: 85vh;
    display: flex;

    .past-container {
      position: absolute;
      bottom: 5vh;
    }

    .past-year {
      margin-left: 1vh;

      img {
        width: 10.2vh;
        margin-left: 2.5vh;
      }
    }
  }
</style>
